import kebabCase from 'lodash/kebabCase'

const concertStatusIcons: Record<string, string> = {
  // handle-name => icon
  // 'op-het-web': 'app-circled-exclamation-mark',
  geannuleerd: 'app-circled-exclamation-mark',
  verplaatst: 'app-circled-exclamation-mark',
}

export function setupConcertStatus(status: string | null | undefined, translationGroup: string) {
  const handle = status && status.length > 0 ? kebabCase(status) : undefined
  const { t_ } = setupTranslationPrefixer('iConcert', translationGroup)

  return {
    concertStatusLabel: handle && concertStatusIcons[handle] ? t_(handle) : undefined,
    concertStatusIcon: (handle && concertStatusIcons[handle]) ?? undefined,
  }
}
